import { useMemo } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { persistTransferWizardFragmentForSession } from '@/lib/utils/impersonateReturnPath'
import type { TransferFragment } from '../types'
import { parseFragment } from '../utils/transferProcessFragment'

const PAGE_HEADER_LABELS: Record<TransferFragment, string> = {
  transfer_property: 'TRANSFER PROPERTY',
  transfer_company: 'TRANSFER COMPANY',
  transfer_resident: 'TRANSFER RESIDENT',
  merge_property: 'MERGE PROPERTY',
  split_property: 'SPLIT PROPERTY',
}

export function useTransferProcessRouting() {
  const { id: routeId = '', companyId: routeCompanyId } = useParams<{
    id: string
    companyId?: string
  }>()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const navigate = useNavigate()

  const fragment = useMemo(() => parseFragment(location.hash), [location.hash])

  useEffect(() => {
    if (fragment) persistTransferWizardFragmentForSession(fragment)
  }, [fragment])

  const pageHeaderTitle = useMemo(() => {
    if (!fragment) return 'TRANSFER'
    return PAGE_HEADER_LABELS[fragment]
  }, [fragment])

  const statusParam = searchParams.get('status') || ''
  const processIdParam = searchParams.get('process_id') || ''
  const processNotesIdParam = searchParams.get('process_id_notes') || ''
  const sourceParam = searchParams.get('source') || ''

  return {
    navigate,
    location,
    fragment,
    pageHeaderTitle,
    entityId: routeId,
    newCompanyIdFromRoute: routeCompanyId || '',
    statusParam,
    processIdParam,
    processNotesIdParam,
    sourceParam,
  }
}
